/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState, useCallback, useEffect } from 'react';
import { IoMdTrash } from 'react-icons/io';
import EditIcon from '@material-ui/icons/Edit';
import { useToast } from '../../hooks/toast';
import Button from '../../components/Button';
import LoaderModal from '../../components/LoaderModal';
import { ArrayFilters } from '../../interfaces/ticket';
import ConfirmationModal from '../../components/ConfirmationModal';
import DepartmentsTable from './components/DepartmentsTable';
import DepartmentsOrange from '../../assets/departmentsOrange.svg';

import AddDepartmentModal from './components/AddDepartmentModal';
import EditDepartmentModal from './components/EditDepartmentModal';

import {
  Row,
  Column,
  InfoContainer,
  InfoItem,
  IconContainer,
} from '../../styles/components';

import DepartamentosService, {
  Departamento,
} from '../../services/departamentos';

import { Container, Title, ButtonsContainer } from './styles';

const Departments: React.FC = () => {
  const service = { DepartamentosService: new DepartamentosService() };
  const { addToast } = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [departamentos, setDepartamentos] = useState<Departamento[]>([]);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [removeDepartment, setRemoveDepartment] = useState<boolean>(false);
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null);

  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });

  const getDepartments = useCallback(async () => {
    try {
      setLoading(true);
      const response = await service.DepartamentosService.getDepartamentos();
      setDepartamentos(response.data.DepartamentoLista);
      setTotalRows(response.data.DepartamentoListaQuantidade);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  const handleAdd = useCallback(async (name: string) => {
    try {
      setLoading(true);
      await service.DepartamentosService.adicionarDepartamento(name);
      setLoading(false);
      setShowAddModal(false);
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Departamento cadastrado com sucesso!!',
      });
      getDepartments();
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
      setLoading(false);
      if (error.response.status === 500) {
        addToast({
          type: 'error',
          title: 'Erro interno do servidor',
          description: 'Contacte a administração do site',
        });
      } else {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
        });
      }
    }
  }, []);

  const handleEdit = useCallback(async (name: string, code: number) => {
    try {
      setLoading(true);
      await service.DepartamentosService.editarDepartamento(
        code.toString(),
        name,
      );
      setLoading(false);
      setShowEditModal(false);
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Departamento Editado com sucesso!!',
      });
      getDepartments();
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
      setLoading(false);
      setShowEditModal(false);
      if (error.response.status === 500) {
        addToast({
          type: 'error',
          title: 'Erro interno do servidor',
          description: 'Contacte a administração do site',
        });
      } else {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
        });
      }
    }
  }, []);

  const handleRemoveDepartment = useCallback(async (data: any) => {
    try {
      await service.DepartamentosService.deletarDepartamento(data.codigo);
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Departamento excluido com sucesso!!',
      });
      getDepartments();
    } catch (err: any) {
      const { ...error } = err;
      if (
        error.response.data.Summary.ErrorCollection.DataValidationErros[0]
          .ErrorMessage
      ) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
        });
      }
    }
  }, []);

  const handleShowRemove = useCallback((data: any) => {
    setSelectedDepartment(data);
    setRemoveDepartment(true);
  }, []);

  const handleShowEdit = useCallback((data: any) => {
    setSelectedDepartment(data);
    setShowEditModal(true);
  }, []);

  useEffect(() => {
    getDepartments();
  }, [filters]);

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="2" medium="2" large="2">
          <IconContainer align="center">
            <img src={DepartmentsOrange} alt="Departamentos" />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <Title>Departamentos</Title>
          <div className="buttons">
            <Button
              color="orange"
              padding="1"
              type="button"
              rounded
              onClick={() => setShowAddModal(true)}
            >
              ADICIONAR DEPARTAMENTO
            </Button>
          </div>
        </Column>
      </Row>
      <Row>
        <Column small="2" medium="2" large="2">
          <InfoContainer className="departments">
            <InfoItem>
              <span className="info">&#9432;</span>

              <span>
                <p>
                  Um departamento é um grupo de funcionários. No módulo de
                  funcionários você deve informar o departamento ao qual cada
                  funcionário pertence.
                </p>
                <br />
                <p>
                  Para conveniência, ao fazer um novo Pedido de Recarga, você
                  escolhe para qual departamento o pedido atende, e dessa
                  maneira cada funcionário daquele departamento recebe os
                  créditos que serão comprados.
                </p>
              </span>
            </InfoItem>
          </InfoContainer>
        </Column>
        <Column small="10" medium="10" large="10">
          <DepartmentsTable
            data={departamentos}
            columns={[
              {
                name: 'Departamento',
                selector: 'Nome',
              },
              /* {
                name: 'Código',
                selector: 'CodigoDepartamento',
              }, */
              {
                name: 'Ações',
                selector: 'CodigoDepartamento',
                maxWidth: '110px',
                cell: ({ CodigoDepartamento, Nome }: any) => (
                  <>
                    <ButtonsContainer>
                      <button
                        type="button"
                        className="edit"
                        title="Editar"
                        onClick={() =>
                          handleShowEdit({
                            codigo: CodigoDepartamento,
                            nome: Nome,
                          })
                        }
                      >
                        <EditIcon style={{ color: '#EB5E35' }} />
                      </button>
                      <button
                        type="button"
                        className="trash"
                        title="Remover"
                        onClick={() =>
                          handleShowRemove({
                            codigo: CodigoDepartamento,
                            nome: Nome,
                          })
                        }
                      >
                        <IoMdTrash style={{ color: '#EB5E35' }} />
                      </button>
                    </ButtonsContainer>
                  </>
                ),
              },
            ]}
            loading={loading}
            totalRows={totalRows}
            perPage={perPage}
            onChangePage={handleChangePerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            emptyText="Nenhum Departamento cadastrado"
          />
        </Column>
      </Row>

      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
      {showAddModal && (
        <AddDepartmentModal
          handleClose={() => setShowAddModal(false)}
          handleAdd={handleAdd}
          show={showAddModal}
          title="Adicionar Departamento"
        />
      )}
      {showEditModal && (
        <EditDepartmentModal
          handleClose={() => setShowEditModal(false)}
          handleEdit={handleEdit}
          show={showEditModal}
          code={selectedDepartment.codigo}
          nome={selectedDepartment.nome}
          title="Editar Departamento"
        />
      )}
      {removeDepartment && (
        <ConfirmationModal
          title="Remoção de departamento"
          text={`Tem certeza que você deseja remover ${selectedDepartment.nome}?`}
          show={removeDepartment}
          handleClose={() => setRemoveDepartment(false)}
          handleSuccess={() => handleRemoveDepartment(selectedDepartment)}
        />
      )}
    </Container>
  );
};

export default Departments;
